import * as React from "react";
import {
  Accordion as BaseAccordion,
  AccordionProps,
  Panel as BasePanel,
  PanelProps,
  StatefulPanel as BaseStatefulPanel,
  StatefulPanelProps,
} from "baseui/accordion";
import { mergeOverrides } from "baseui";

const StatefulPanel: React.FC<StatefulPanelProps> = ({ overrides, ...props }) => {
  const mergedOverrides = mergeOverrides(
    {
      Content: {
        style: ({ $theme }) => ({
          backgroundColor: $theme.colors.backgroundSecondary,
        }),
      },
    },
    overrides
  );
  return <BaseStatefulPanel overrides={mergedOverrides} {...props} />;
};

const Panel: React.FC<PanelProps> = ({ overrides, ...props }) => (
  <BasePanel overrides={overrides} {...props} />
);

const Accordion: React.FC<AccordionProps> = ({
  overrides = {
    Content: {
      style: ({ $theme }) => ({
        backgroundColor: $theme.colors.backgroundSecondary,
      }),
    },
  },
  ...props
}) => <BaseAccordion overrides={overrides} {...props} />;

export { Accordion, Panel, StatefulPanel };
